import { Box } from "@mui/material";
import { smLogo } from "../../iconsImports";

const Loader = ({ loading, children }) => {
  return (
    <div>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(10px)", // Soft blur for background
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
            zIndex: 9998,
            flexDirection: "column",
            color: "#fff",
            textAlign: "center",
            overflow: "hidden",
            height: "100vh",
            width: "100vw",
          }}
        >
          <div className="loader-container">
            <img
              src={smLogo}
              style={{
                cursor: "pointer",
                width: 120,
                animation: "floatLogo 2s ease-in-out infinite",
              }}
              alt="Loading..."
            />
          </div>

          {/* Loading Progress Text */}
          <div className="loader-text">
            Please wait, we're setting things up for you...
          </div>

          {/* Progress bar animation */}
          <div className="progress-bar">
            <div className="fill" />
          </div>
        </Box>
      )}
      {children}

      <style jsx>{`
        .loader-text {
          margin-top: 30px;
          font-size: 22px;
          font-weight: 700;
          letter-spacing: 1px;
          opacity: 0;
          animation: fadeInText 0.5s ease-in-out forwards;
        }

        .loader-container {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          animation: bounce 2s infinite alternate;
        }

        .bubbles {
          position: absolute;
          top: 10%;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
        }

        .bubble {
          position: absolute;
          background-color: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: floatBubbles 4s ease-in-out infinite;
        }

        .bubble:nth-child(1) {
          left: 30%;
          animation-duration: 5s;
        }

        .bubble:nth-child(2) {
          left: 60%;
          animation-duration: 3s;
        }

        .bubble:nth-child(3) {
          left: 90%;
          animation-duration: 4.5s;
        }

        @keyframes floatBubbles {
          0% {
            transform: translateY(0) scale(0.8);
          }
          50% {
            transform: translateY(-30px) scale(1);
          }
          100% {
            transform: translateY(0) scale(0.8);
          }
        }

        @keyframes floatLogo {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @keyframes fadeInText {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes bounce {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-15px);
          }
        }

        .progress-bar {
          margin-top: 50px;
          width: 100px;
          height: 8px;
          background-color: rgba(255, 255, 255, 0.3);
          border-radius: 5px;
          overflow: hidden;
        }

        .fill {
          width: 0%;
          height: 100%;
          background: linear-gradient(90deg, #ff6b6b, #f9a826);
          animation: fillBar 3s ease-in-out infinite;
        }

        @keyframes fillBar {
          0% {
            width: 0%;
          }
          50% {
            width: 50%;
          }
          100% {
            width: 100%;
          }
        }
        @media (max-width: 600px) {
          .loader-text {
            font-size: 1rem;
            max-width: 90%;
          }

          .progress-bar {
            max-width: 150px;
            width: 70%;
          }

          .loader-logo {
            width: 25vw;
          }
        }

        @media (max-width: 400px) {
          .loader-text {
            font-size: 0.9rem;
          }

          .progress-bar {
            max-width: 120px;
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;
